
export enum EstadoNotaEletronica {
    EM_DEFINICAO = 'EM_DEFINICAO',
    AUTORIZADA = 'AUTORIZADA',
    CANCELADA = 'CANCELADA',
    DENEGADA = 'DENEGADA',
    INUTILIZADA = 'INUTILIZADA',
    REJEITADA = 'REJEITADA',
    ENVIADA = 'ENVIADA',
    COM_PROBLEMAS = 'COM_PROBLEMAS',
    APROVADO = 'APROVADO'
}